import { cn } from '@/lib/core/utils/cn';

interface BookHubsProps {
  hubs: string[];
  activeHub: string;
  onHubChange: (hub: string) => void;
}

export function BookHubs({ hubs, activeHub, onHubChange }: BookHubsProps) {
  if (hubs.length <= 1) return null;

  return (
    <div className="mx-auto inline-flex flex-wrap justify-center gap-2.5 rounded-[20px] bg-[#f4f4f4] p-1">
      {hubs.map(hub => (
        <button
          key={hub}
          type="button"
          onClick={() => onHubChange(hub)}
          className={cn(
            'font-inter rounded-[20px] px-4 text-[14px] font-medium tracking-[0.5px] text-[#1a1a1a] transition-colors',
            activeHub === hub ? 'bg-white py-[6px]' : 'py-[4px]'
          )}
        >
          {hub}
        </button>
      ))}
    </div>
  );
}
